import { required, email } from 'vee-validate/dist/rules'; // eslint-disable-line no-unused-vars
import { extend } from "vee-validate"; //import extend function from vee-validate

extend("required", {
  validate(value, { labelId }) { // eslint-disable-line no-unused-vars
    return {
      required: true,
      valid: (value && !/^\s*$/.test(value)) && [null, undefined, false, []].indexOf(value) === -1
    };
  },
  computesRequired: true,
  params: ["labelId"],
  message: `<a href="{labelId}">{_field_}: Must be completed</a>`,
});

extend("email", {
  validate(value, { labelId }) { // eslint-disable-line no-unused-vars
    const emailReg = /^[a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/
    return {
      required: true,
      valid: email.validate(value) || emailReg.test(value)
    };
  },
  computesRequired: true,
  params: ["labelId"],
  message: `<a href="{labelId}">{_field_}: Must be a valid email address</a>`,
});